import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, NgForm, FormGroupDirective, UntypedFormGroup, Validators } from '@angular/forms';
import { ApiManagerService } from '../../services/api-manager.service';
import * as moment from 'moment';
import { SessionStore } from '../../stores/session.store';
import { MatDialog } from '@angular/material/dialog';
import { SelectUsersDialogComponent } from '@ildes/basic/select-users-dialog/select-users-dialog.component';
const PARTS = [
  {
    id:'NATURAL',
    description:'Natural'
  },
  {
    id:'JURIDIC',
    description:'Jurídico'
  }
];

const CONTRACT_TYPES = [
  {
    id:'SOC',
    description:'Contrato de sociedad'
  },
  {
    id:'CONC',
    description:'Contrato de concesión'
  },
  {
    id:'WORK',
    description:'Contrato de obra'
  }
];

@Component({
  selector: 'app-create-project',
  templateUrl: './create-project.component.html',
  styleUrls: ['./create-project.component.css']
})
export class CreateProjectComponent implements OnInit {
  contractTypes = CONTRACT_TYPES;
  contractType;
  projectForm;
  loading;
  subscriptionDate;
  minutesDate;
  contractParts = PARTS;
  dinamicParts = [
    {
      name: '',
      type: '',
      percent: 0,
    }
  ];

  public searchDepartmentAdapter;
  public searchCityAdapter;
  private currentDepartment;
  public accountableOperativeSection;
  public accountableAdministrativeSection;
  public accountableThirdAdministrativeSection = {
    name: '',
    email: '',
  }
  get days() {
    if (!this.endDate) {
      return;
    }
    return this.endDate.diff(this.minutesDate || this.subscriptionDate, 'days');
  }

  get endDate() {
    const currentDate = moment(this.minutesDate || this.subscriptionDate);
    const years = this.projectForm.controls.years.value;
    const months = this.projectForm.controls.months.value;

    if(!currentDate.isValid() || (years === 0 && months === 0)) {
      return null;
    }
    return currentDate
      .add(years, 'year')
      .add(months, 'month')
      .subtract(1, 'day');
  }

  get formattedEndDate() {
    return this.endDate?.format('DD/MM/YYYY');
  }

  constructor(
    private apiManager: ApiManagerService,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.searchDepartmentAdapter = (data) => {
      return this.apiManager.getFromCatalog('department', data);
    };
    this.searchCityAdapter = (data) => {
      const classification = this.projectForm.controls.department.value.selected.name;

      return this.apiManager.getFromCatalog('city', { text: data.text, classification});
    };
    this.resetForm();
  }

  private resetForm() {
    this.subscriptionDate = new Date();
    this.minutesDate = false;
    this.projectForm = new UntypedFormGroup({
      name: new UntypedFormControl('', [Validators.required]),
      prefix: new UntypedFormControl('', [Validators.required]),
      object: new UntypedFormControl('', [Validators.required]),
      // contractType: new UntypedFormControl('', [Validators.required]),
      contractNumber: new UntypedFormControl('', [Validators.required]),
      value: new UntypedFormControl('', [Validators.required, Validators.pattern(new RegExp('^[0-9]+$'))]),
      months: new UntypedFormControl(null, [Validators.pattern(new RegExp('^[0-9]+$'))]),
      years: new UntypedFormControl(null, [Validators.pattern(new RegExp('^[0-9]+$'))]),
      address: new UntypedFormControl('', [Validators.required]),
      department: new UntypedFormControl('', [Validators.required]),
      city: new UntypedFormControl('', [Validators.required]),
    }, this.durationShouldBeGreaterThanOne);

  }

  checkPrefix(event) {
    const prefix = event.target.value?.toUpperCase();
    if (prefix?.length !== 4) {
      this.invalidateFormPrefix();

      return;
    }
    this.apiManager.checkPrefix({ prefix }).subscribe((data: any) => {
      if (data.data.exists) {
        this.invalidateFormPrefix();
      } else {
        this.validateFormPrefix();
      }
    }, () =>{

    })
  }

  invalidateFormPrefix() {
    this.projectForm.controls['prefix'].setErrors({'incorrect': true});
  }
  validateFormPrefix() {
    this.projectForm.controls['prefix'].setErrors(null);
  }
  setSubscriptionDate(event) {
    this.subscriptionDate = event.selectedDate;
  }

  setMinutesDate(event) {
    this.minutesDate = event.selectedDate;
  }

  changeDepartment($event) {
    if ( this.currentDepartment && this.currentDepartment !== $event.option.value?.name) {
      this.currentDepartment = $event?.name;
      console.log('reset')
      this.projectForm.controls.city.reset();
    }
  }

  get addressData() {
    return {
      address: this.projectForm.controls.address.value,
      department: this.projectForm.controls.department.value.selected.name,
      city: this.projectForm.controls.city.value.selected.name
    }
  }

  create() {
    const {
      name,
      object,
      contractNumber,
      value,
      prefix,
    } = this.projectForm.controls;
    const length = this.dinamicParts.length;
    const contractParts = this.dinamicParts.slice(0, length - 1);
    const data = {
      parts: contractParts,
      name: name.value,
      object: object.value,
      contractType: this.contractType,
      contractNumber: contractNumber.value,
      value: value.value,
      minutesDate: this.minutesDate || this.subscriptionDate,
      subscriptionDate: this.subscriptionDate,
      duration: this.days,
      address: this.addressData,
      prefix: prefix.value.toUpperCase(),
      accountableAdministrativeSection: this.accountableAdministrativeSection?.map(( {id} ) => id) || [],
      accountableOperativeSection: this.accountableOperativeSection?.map(( {id} ) => id) || [],
      ...this.accountableThirdAdministrativeSection?.name && { accountableThirdAdministrativeSection: [this.accountableThirdAdministrativeSection] }
    };
    this.loading = true;
    this.apiManager.createProject(data).subscribe(() => {
      this.loading = false;
      this.resetForm();
    }, (data) => {
      this.loading = false;
    });
  }

  onAddParticipantsOperativeSection() {
    this.onAddParticipants(2, this.accountableOperativeSection || [])
      .afterClosed()
      .subscribe( (data) => {
        if (data.close) {
          return;
        }

        this.accountableOperativeSection = data.participants;
    });
  }
  onAddParticipantsAdministrativeSection() {
    this.onAddParticipants(1, this.accountableAdministrativeSection || [])
      .afterClosed()
      .subscribe( (data) => {
        if (data.close) {
          return;
        }

        this.accountableAdministrativeSection = data.participants;
    });
  }

  onAddParticipants(maxSelectedUsers, selected = []) {
    return this.dialog.open(SelectUsersDialogComponent, {
      width: '600px',
      height: '600px',
      panelClass: 'responsive-dialog',
      data: { maxSelectedUsers, selected}
    });
  }

  get errorInAccountableSection() {
    if (this.accountableThirdAdministrativeSection?.name && !this.accountableThirdAdministrativeSection?.email) {
      return 'Debe completar el email'
    }
    if (this.accountableThirdAdministrativeSection?.email && !this.accountableThirdAdministrativeSection?.name) {
      return 'Debe completar el nombre'
    }

    return null;
  }

  public toggleMinutesDate() {
    if (this.minutesDate) {
      this.minutesDate = false;

      return;
    }
    this.minutesDate = this.subscriptionDate;
  }

  private durationShouldBeGreaterThanOne(fGroup: UntypedFormGroup) {
    if (!fGroup || !fGroup.get('months') || !fGroup.get('years')) {
      return null;
    }
    if (!fGroup.get('months').touched && !fGroup.get('years').touched) {
      return null;
    }
    return fGroup.get('months').value > 0 || fGroup.get('years').value > 0 ? null : { 'validDuration': true };
  }

  addPart() {
    this.dinamicParts.push({
      name: '',
      percent: 0,
      type: '',
    })
  }


  get disabledAddPart() {
    const last = this.dinamicParts[this.dinamicParts.length -1];

    return !last.name || !last.percent || !last.type;
  }

  removePart(index) {
    this.dinamicParts = this.dinamicParts.filter((_, cIndex) => index!==cIndex);
  }

  get erorInParts () {
    const length = this.dinamicParts.length;

    return  length > 1 && this.dinamicParts.slice(0, length - 1).reduce((sum, part) => part.percent + sum, 0) !== 100;
  }
}
